import { type ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { SellarCreditTwoSignature } from "../../../../../../../../components/sellarCreditTwo/SellarCreditTwoSignature";
import { DialogContent } from "../../../../../../../../components/modal/Dialog";

export const SellarCreditTwoDialogPage = ({
  children,
  className,
  contentClassName,
}: {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
}) => {
  return (
    <DialogContent
      className={twMerge(
        "flex h-full min-h-0 flex-col items-center text-center",
        className,
      )}
    >
      <div
        className={twMerge(
          "flex w-full flex-1 flex-col items-center gap-3",
          contentClassName,
        )}
      >
        {children}
      </div>
      <SellarCreditTwoSignature />
    </DialogContent>
  );
};

export const SellarCreditTwoHeroImage = ({
  src,
  width,
  height,
  className,
}: {
  src: string;
  width: number;
  height: number;
  className?: string;
}) => {
  return (
    <img
      src={src}
      alt=""
      width={width}
      height={height}
      className={twMerge("shrink-0 object-contain", className)}
    />
  );
};
